import {
  componentIdSelector,
  componentNameSelector,
  experimentNameSelector,
  isDynamicSelector,
  liveNowSelector,
  startDateSelector,
  tagsSelector
} from 'app/Canvas/selectors';
import { modifyComponent } from 'app/EditorPane/actions';
import { clearExperiment } from 'app/Experiments/actions';
import { fetchExperiment } from 'app/Experiments/thunks';
import { COMPONENT_NAME_LOCATION, NAME_TAGS_LOCATION, USER_TAGS_LOCATION } from 'lib/const';
import connect from 'utils/store/connect';

import NameAndTags from './components/NameAndTags';

/**
 * map redux state to react component properties
 * @param {object} state - redux state object
 * @returns {object} react props
 */
const mapStateToProps = state => ({
  experimentName: experimentNameSelector(state),
  id: componentIdSelector(state),
  isDynamic: isDynamicSelector(state),
  isLive: liveNowSelector(state),
  name: componentNameSelector(state),

  // FIXME refactor when combining NameAndTags implementations
  schema: {
    name: COMPONENT_NAME_LOCATION,
    nameTags: NAME_TAGS_LOCATION,
    userTags: USER_TAGS_LOCATION
  },
  startDate: startDateSelector(state),
  tags: tagsSelector(state)
});

const mapDispatchToProps = {
  clearExperiment,
  fetchExperiment,
  modify: modifyComponent
};

export default connect(mapStateToProps, mapDispatchToProps)(NameAndTags);
